/**
 * Copyright Mántum All Rights Reserved.
 */
import { XMarkIcon } from '@heroicons/react/24/outline';

type PropTypes = {
    cancelable?: boolean;
    children?: React.ReactNode;
    closable?: boolean;
    message: string;
    negative?: string;
    onClose?: () => void;
    onNegative?: () => void;
    onPositive?: () => void;
    positive?: string;
    testid?: string;
    title: string;
};

export default function Notification(props: PropTypes) {
    const {
        cancelable = true,
        closable = true,
        negative = 'Dismiss',
        positive = 'Undo'
    } = props;

    return (
        <div className='w-full max-w-sm overflow-hidden rounded-md bg-white shadow'>
            <div className='p-4'>
                <div className='flex items-start'>
                    <div className='shrink-0'>{props.children}</div>
                    <div className='ml-3 w-0 flex-1'>
                        <p className='text-base font-medium text-gray-900'>
                            {props.title}
                        </p>
                        <p className='mt-1 text-base text-gray-500'>
                            {props.message}
                        </p>
                        <div className='mt-3 flex gap-4'>
                            <button
                                className='text-base font-medium text-primary hover:text-primary-dark'
                                onClick={props.onPositive}
                                type='button'
                                data-testid={
                                    props.testid
                                        ? `${props.testid}-positive`
                                        : null
                                }
                            >
                                {positive}
                            </button>
                            {cancelable && (
                                <button
                                    className='text-base font-medium text-gray-500 hover:text-gray-900'
                                    onClick={props.onNegative}
                                    type='button'
                                    data-testid={
                                        props.testid
                                            ? `${props.testid}-negative`
                                            : null
                                    }
                                >
                                    {negative}
                                </button>
                            )}
                        </div>
                    </div>
                    {closable && (
                        <div className='ml-4 flex shrink-0'>
                            <button
                                className='rounded-md hover:text-gray-500'
                                onClick={props.onClose}
                                type='button'
                                data-testid={
                                    props.testid
                                        ? `${props.testid}-close`
                                        : null
                                }
                            >
                                <XMarkIcon className='h-5 w-5' />
                            </button>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
}
